import { render } from "./FeaturesSection.vue?vue&type=template&id=538b1117&scoped=true"
const script = {}

import "./FeaturesSection.vue?vue&type=style&index=0&id=538b1117&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538b1117"]])

export default __exports__